import styled, { css, keyframes } from 'styled-components'
import IconCopy from '../assets/img/icon-copy.svg'

const showData = keyframes`
  from {
    opacity: 0;
  } to {
    opacity: 1;
  }
`

export const PromotorVendasHeader = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 24px;
  transition: all ease-in-out 1000ms;
  animation: ${showData} 1s;

  p {
    font-size: 14px;
    position: relative;

    &:first-child {
      margin-right: 40px;
    }
  }
`

const showTooltip = keyframes`
  from {
    opacity: 0;
    top: 0;
  } to {
    opacity: 1;
    top: -45px;
  }
`

type CopyTooltipProps = {
  active: boolean
}

export const CopyTooltip = styled.span<CopyTooltipProps>`
  ${({ active }) => css`
    display: none;
    position: absolute;
    padding: 10px 15px;
    top: -45px;
    right: -30px;
    min-width: 130px;

    background: #ffffff;
    border: 1px solid #afaeae;
    border-radius: 5px;
    font-size: 11px;
    font-weight: bold;
    line-height: 15px;
    text-transform: initial;
    transition: all 400ms;

    ${active &&
    css`
      display: block;
      animation: ${showTooltip} 400ms ease;
    `}
  `}
`

export const CopyButton = styled.input`
  cursor: pointer;
  background: #ffffff;
  padding: 8px 10px;
  margin-left: 5px;
  border: 1px solid #cccccc;
  border-radius: 5px;
  font-weight: 800;
  text-transform: uppercase;
  position: relative;
  width: 100px;
  background-image: url(${IconCopy});
  background-size: 16px;
  background-repeat: no-repeat;
  background-position: right;
  background-position-x: 70px;

  &::selection {
    background: #ffffff;
  }
`

export const FilterDesktopContainer = styled.div`
  &.vendas {
    display: flex;
    align-items: center;
  }

  @media (max-width: 1170px) {
    display: none;
  }
`
